// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { CssBaseline } from '@mui/material';
import type { FC, HTMLProps, ReactNode } from 'react';
import Sidebar from './Sidebar';
import { EmergencyLayout } from 'features/emergency';
import HotjarInitial from 'lib/hotjar/HotjarInitial';
import classNames from 'classnames';

interface LayoutProps {
  children: ReactNode;
  hideSidebar?: boolean;
  className?: HTMLProps<HTMLElement>['className'];
}

const Layout: FC<LayoutProps> = ({ children, hideSidebar = false, className }) => {
  return (
    <HotjarInitial>
      <CssBaseline />
      <EmergencyLayout>
        {!hideSidebar && <Sidebar />}
        <div
          className={classNames(
            'flex flex-1 flex-col overflow-hidden overflow-y-auto bg-white rounded-md pt-3 2xl:pt-6 px-3 2xl:px-6',
            className
          )}
        >
          {children}
        </div>
      </EmergencyLayout>
    </HotjarInitial>
  );
};
export default Layout;
